import axios from "axios"

const state = function() {
  return {
    vacancies: [],
    vacanciesLoading: false,
    vacanciesLoaded: false
  }
}

const getters = {}

const mutations = {
  SET_VACANCIES: (state, payload) => {
    state.vacancies = payload
  },

  SET_VACANCIES_LOADING: (state, payload) => {
    state.vacanciesLoading = payload
  },

  SET_VACANCIES_LOADED: (state, payload) => {
    state.vacanciesLoaded = payload
  }
}

const actions = {
  async fetchSportMasterVacancies({ commit, dispatch }, tags) {
    commit('SET_VACANCIES_LOADING', true);

    await axios.get(`/1.0/spec-private/sportmaster/move-vacancies`)
      .then(x => {
        commit("SET_VACANCIES", x.data.data)
        commit('SET_VACANCIES_LOADED', true)
      })
      .finally(() => {
        commit('SET_VACANCIES_LOADING', false)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
